module.exports = __webpack_public_path__ + "static/media/Colette Curve Queen Headboard - 155 cm_Teal.d9a24ef8.png";